export interface MaterialMasterRecord {
  materialNumber: string;
  description: string;
  type: string;
  manufacturer: string;
  storageLocations: string[];
  manualState?: "created" | "updated" | null;
}

export interface MaterialMasterVersionInfo {
  id: number | null;
  versionNumber: number | null;
  sourceFilename: string | null;
  sourceHash: string | null;
  sourceDate: string | null;
  activatedAt: string | null;
  manualRevision?: string | null;
}

export interface MaterialMasterDataSnapshot {
  records: MaterialMasterRecord[];
  createdAt: string | null;
  source: "server" | "indexed-db" | "legacy-network";
  version: MaterialMasterVersionInfo;
  savedAt: string | null;
  manualRevision?: string | null;
}

export type MaterialMismatchField = "materialText" | "materialType" | "storageAddress";

export interface MaterialMasterMismatchItem {
  field: MaterialMismatchField;
  label: string;
  labelValue: string;
  masterValue: string;
}

export interface MaterialMasterComparison {
  materialNumber: string;
  status: "idle" | "loading" | "not-found" | "match" | "mismatch" | "error";
  record: MaterialMasterRecord | null;
  mismatches: MaterialMasterMismatchItem[];
  masterDataCreatedAt: string | null;
  message: string | null;
}

export interface MaterialMasterSuggestion {
  record: MaterialMasterRecord;
  score: number;
  typeScore: number;
  textScore: number;
  storageScore: number;
}

export function createEmptyMaterialMasterComparison(): MaterialMasterComparison {
  return {
    materialNumber: "",
    status: "idle",
    record: null,
    mismatches: [],
    masterDataCreatedAt: null,
    message: null,
  };
}


export interface MaterialMasterAvailableChange {
  key: string;
  changeType: "added" | "changed" | "removed" | string;
  oldData: Record<string, unknown> | null;
  newData: Record<string, unknown> | null;
  changedAt: string | null;
}

export interface MaterialMasterAvailableChanges {
  versionNumber: number | null;
  manualRevision: string | null;
  newEntries: number;
  changedEntries: number;
  removedEntries: number;
  changes: MaterialMasterAvailableChange[];
}
